// extracted by mini-css-extract-plugin
export var modal = "_bj-0";